import { HomeFilledMinor } from "@shopify/polaris-icons";
import { IMenuItems, MenuItemType } from "./MenuModel";

const dashboard: IMenuItems = {
  id: "dashboard",
  type: MenuItemType.Group,
  title: "Dashboard",
  url: "/",
  icon: HomeFilledMinor,
  featureHighlight: true
};

export default dashboard;
